import _get from 'lodash/get';

export const selectFlow = state => _get(state, ['flow']);
